import { A as y, E as P, P as k, b as I, n as p, t as _ } from "./element-CV9utnHJ.js";
import { e as m, i as S, t as b } from "./directive-oAbCiebi.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class h extends S {
  constructor(t) {
    if (super(t), this.it = y, t.type !== b.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(t) {
    if (t === y || t == null) return this._t = void 0, this.it = t;
    if (t === P) return t;
    if (typeof t != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (t === this.it) return this._t;
    this.it = t;
    const n = [t];
    return n.raw = n, this._t = { _$litType$: this.constructor.resultType, strings: n, values: [] };
  }
}
h.directiveName = "unsafeHTML", h.resultType = 1;
const R = m(h);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class l extends h {
}
l.directiveName = "unsafeSVG", l.resultType = 2;
const f = m(l);
var C = Object.defineProperty, E = Object.getOwnPropertyDescriptor, c = (e, t, n, s) => {
  for (var o = s > 1 ? void 0 : s ? E(t, n) : t, d = e.length - 1, u; d >= 0; d--)
    (u = e[d]) && (o = (s ? u(t, n, o) : u(o)) || o);
  return s && o && C(t, n, o), o;
};
const w = "https://punkt-cdn.oslo.kommune.no/latest/icons/";
typeof window < "u" && (window.pktFetch = window.pktFetch === void 0 ? fetch : window.pktFetch, window.pktIconPath = window.pktIconPath || w);
const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"></svg>', r = {}, T = 2, F = 1500, g = typeof Storage < "u" && typeof sessionStorage < "u", $ = (e) => window.pktFetch(e).then((t) => {
  if (!t.ok)
    throw new Error("Missing icon: " + e);
  return t.text();
}), v = async (e, t = T) => {
  try {
    return await $(e);
  } catch {
    return t > 0 ? (await new Promise((s) => setTimeout(s, F)), v(e, t - 1)) : (console.error("Failed to fetch icon: " + e), a);
  }
}, A = async (e, t) => {
  const n = t + e + ".svg";
  return g && sessionStorage.getItem(n) ? sessionStorage.getItem(n) : n in r ? r[n] : typeof window < "u" && typeof window.pktFetch == "function" ? (r[n] = v(n).then((s) => (s !== a && g && sessionStorage.setItem(n, s), delete r[n], s)), r[n]) : a;
};
let i = class extends k {
  constructor() {
    super(...arguments), this.path = typeof window < "u" ? window.pktIconPath : w, this.name = "", this.icon = f(a), this._updatedProps = [];
  }
  connectedCallback() {
    super.connectedCallback(), this.classList.add("pkt-icon");
  }
  async attributeChangedCallback(e, t, n) {
    super.attributeChangedCallback(e, t, n), (e === "name" || e === "path") && this.getIcon(this.name);
  }
  async updated(e) {
    super.updated(e), (e.has("name") || e.has("path")) && this.getIcon(this.name);
  }
  async getIcon(e = "") {
    if (this._updatedProps.length > 0) {
      this.path || (this.path = typeof window < "u" ? window.pktIconPath : w);
      try {
        this.icon = f(
          await A(this.name || "", this.path)
        );
      } catch {
        this.icon = f(a);
      }
      this._updatedProps = [];
    } else
      this._updatedProps.includes(e) || this._updatedProps.push(e);
  }
  render() {
    return I`${this.name && this.icon}`;
  }
};
c([
  p({ type: String, reflect: !1 })
], i.prototype, "path", 2);
c([
  p({ type: String, reflect: !0 })
], i.prototype, "name", 2);
c([
  p({ type: SVGElement })
], i.prototype, "icon", 2);
c([
  p({ type: Array, noAccessor: !0 })
], i.prototype, "_updatedProps", 2);
i = c([
  _("pkt-icon")
], i);
export {
  i as P,
  R as o
};
